module.exports = __webpack_public_path__ + "img/mowerwalk_stopped.4ea543b2.svg";